module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    style: (_vm.styleObject),
    attrs: {
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.label
    },
    on: {
      "input": function (e) { return (_vm.label = e.target.value); },
      "blur": _vm.syncLabelAndValue
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40112f07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/components/number-input.vue
// module id = 3140
// module chunks = 0